export enum ErrorTypes {
  UnknownError = 0,
  GeneralError = 1,
  InternalServerError = 500,
}
